import { useSites, useUser } from 'store'

const useFocus = () => {
  const [{selected, treeRef}] = useSites()
  const [user] = useUser()

  const onFocus = (site) => {
    if (user?.accounts?.length === 1 || selected.length > 1) {
      return
    } else if (selected.some(({sf_id}) => sf_id === site.sf_id)) {
      return
    }
    const account = user?.accounts.find(({sf_id}) => sf_id === site.sf_id)
    if (!account || !account.hierarchie) {
      return
    }
    const selection = account.hierarchie
      .map(sf_id => user?.accounts.find(account => account.sf_id === sf_id))
      .filter(Boolean)
    if (selection.length !== account.hierarchie.length) {
      return
    }
    // @ts-expect-error unknown
    treeRef.reset(selection)
  }

  const onBlur = () => {
    if (selected.length !== 1 || user?.accounts.length === 1) {
      return
    }
    // @ts-expect-error unknown
    treeRef.reset([])
  }

  return {
    onFocus,
    onBlur
  }


}

export default useFocus